module.exports = __webpack_public_path__ + "img/menu1-4.361bb0a0.jpg";